const storeFetched = ({ commit }, val) => {
  commit('STORE_FETCHED', val);
};
export default {
  storeFetched
};
